import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../dialogs/Dialog';
import _ from 'lodash';

/**
 * Edit text cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */

export const EditTextCell = ({ getColumns }) => {
  class EditTextCell extends React.Component {
    timeout = null;

    constructor(props) {
      super(props);

      const { field, dataItem } = props;
      const dataValue = _.get(dataItem, field.split('.')) || '';

      this.state = {
        value: dataValue,
        isDialogOpen: false,
      }
    }

    handleDialogClose = () => {
      this.setState({ isDialogOpen: false });
    }

    handleDialogOpen = () => {
      this.setState({ isDialogOpen: true });
    }

    handleDialogConfirm = async (e) => {
      this.setState({ isDialogOpen: false });

      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e,
        value: this.state.value
      });
    }

    handleFocus = (e) => {
      e.target.selectionStart = 0;
      e.target.selectionEnd = e.target.value.length;
    }

    handleTextAreaKeyDown = (e) => {
      if (e.key === "Enter") {
        e.stopPropagation();
      }
      if (e.key === "Escape") {
        this.setState({ isDialogOpen: false });
        e.stopPropagation();
      }
    }

    handleKeyDown = (e) => {
      var k = e.keyCode;
      if (e.ctrlKey || k === 8 || k === 9 || k === 13 || k === 27 ||
        (k >= 16 && k <= 20) ||
        (k >= 33 && k <= 40) ||
        (k >= 44 && k <= 46)) {

        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
          this.handleTimeout(new Event('change'));
          e.stopPropagation();
          setTimeout(() => { e.target.dispatchEvent(new KeyboardEvent('keydown', e)); }, 500);
        }
        return;
      }
    }

    handleTimeout = (e) => {
      const { field, dataItem, onChange } = this.props;

      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e,
        value: this.state.value
      });

      this.timeout = null;
    }

    handleChange = (e) => {
      this.setState({ value: e.target.value });

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(() => { this.handleTimeout(e) }, 1000);
    }

    componentDidUpdate(prevProps, prevState) {
      const { field, dataItem } = this.props;
      const dataValue = _.get(dataItem, field.split('.')) || '';
      const prevDataValue = _.get(prevProps.dataItem, prevProps.field.split('.')) || '';
      if (prevDataValue !== dataValue) {
        this.setState({ value: dataValue });
      }
    }

    render() {
      const { dataItem, field, style, colSpan, columnIndex, level } = this.props;
      const className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;
      const column = getColumns().find(item => item.field === field)

      const td = (
        <td colSpan={colSpan}
          className={className}
          style={style}
          role="gridcell"
          aria-colindex={(columnIndex || 0) - (level || 0) + 1}
          aria-selected={false}
          tabIndex="0"
        >
          {((dataItem.inEdit === true || dataItem.inEdit === field) && column.editable !== false) ? (
            <input
              style={{ width: "100%" }}
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              className={"k-textbox"}
              value={this.state.value}
              onDoubleClick={this.handleDialogOpen}
            />
          ) : (
            this.state.value
          )}
          {this.state.isDialogOpen && <Dialog
            title={"Editácia textu"}
            isOpen={this.state.isDialogOpen}
            onClose={this.handleDialogClose}
            onConfirm={this.handleDialogConfirm}
          >
            <textarea
              className="k-textarea"
              value={this.state.value}
              onChange={(e) => { this.setState({ value: e.target.value }); }}
              style={{ width: "100%" }}
              autoFocus={true}
              onFocus={this.handleFocus}
              onKeyDown={this.handleTextAreaKeyDown}
            />
          </Dialog>
          }
        </td>
      );

      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }
  EditTextCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  }

  return EditTextCell;
}